const labour = (project) => {
  return [{
    id: 'meta.price',
    title: 'Price per day',
    default: 0,
    inputProps: {
      type: 'number',
    },
    helperText: 'What is the rate per day?',
    validate: {
      type: 'number',
      methods: [
        ['required', 'Required'],
        ['moreThan', 0, 'Must be more than zero'],
      ],
    },
  }]
}

export default labour